import * as Sentry from '@sentry/core';
export class MpLogger {
    _app;
    _console = {
        info: console.info,
        warning: console.warn,
        debug: console.debug,
        error: console.error,
    };
    constructor(app) {
        this._app = app;
    }
    info(message, tags) {
        this.log(message, 'info', tags);
    }
    warn(message, tags) {
        this.log(message, 'warning', tags);
    }
    debug(message, tags) {
        this.log(message, 'debug', tags);
    }
    error(message, tags) {
        this.log(message, 'error', tags);
    }
    log(message, severity, tags) {
        const formattedMessage = `[${this._app} ${severity.toUpperCase()}] ${message}`;
        if (process.env.NODE_ENV === 'development') {
            this._console[severity](formattedMessage, tags);
        }
        else {
            if (severity === 'debug' || severity === 'info') {
                return;
            }
            Sentry.captureMessage(formattedMessage, { level: severity, tags });
        }
    }
    setUser(id, email) {
        Sentry.setUser({
            id,
            email,
        });
    }
    setTag(key, value) {
        return Sentry.setTag(key, value);
    }
    unsetUser() {
        Sentry.setUser(null);
    }
}
//# sourceMappingURL=index.js.map